/**
 * Updates a moment property using a dot-notation path
 * @param {Array} chapters - Array of chapter objects
 * @param {string} momentId - ID of the moment to update
 * @param {string} propertyPath - Dot-notation path to the property (e.g., 'beforeTouch.voiceOver')
 * @param {*} value - New value for the property
 * @returns {Array} Updated chapters array
 */
export function updateMomentProperty(chapters, momentId, propertyPath, value) {
  return chapters.map((ch) => ({
    ...ch,
    moments: ch.moments.map((m) => {
      if (m.id !== momentId) return m;
      const newMoment = { ...m };
      const keys = propertyPath.split('.');

      if (keys.length === 1) {
        // Simple property update
        newMoment[keys[0]] = value;
      } else {
        // Nested property update
        let current = newMoment;
        for (let i = 0; i < keys.length - 1; i++) {
          if (!current[keys[i]] || typeof current[keys[i]] !== 'object') {
            current[keys[i]] = {};
          } else {
            current[keys[i]] = { ...current[keys[i]] };
          }
          current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = value;
      }
      return newMoment;
    }),
  }));
}
